export const TAG_FEATURE = "feature";
export const TAG_EVIDENCE = "evidence";

export const CONTEXT_APP = "App context";
